import React from "react";

import {
  Button,
  Drawer,
  DrawerBody,
  DrawerHeader,
  DrawerHeaderTitle,
  useRestoreFocusSource,
  useRestoreFocusTarget,
} from "@fluentui/react-components";
import { Dismiss24Regular } from "@fluentui/react-icons";
import { IEmployee, INotification, SelectItem } from "library/types";
// -- Fabric UI

// -- Components
import styled from "styled-components";

import { useIsMobile } from "hooks/useIsMobile";

import { IGrecoPanelStrings } from "./IGrecoPanelStrings";
import { INotificationStrings } from "./Notification/INotificationStrings";
import Notification from "./Notification/Notification";
import { PanelType as GrecoPanelType } from "./PanelType";
import { SettingsPanel } from "./Settings/SettingsPanel";

interface IProps {
  panelIsOpen: any;
  onDismiss: () => void;
  panelType: GrecoPanelType | null;
  userData: IEmployee | null;
  darkMode?: any;
  headerConfig: any;
  panelStrings?: IGrecoPanelStrings;
  languageOptions?: SelectItem[];
  defaultSelectedLanguage?: string;
  onChangeLanguage: (
    event: React.FormEvent<HTMLDivElement>,
    option?: SelectItem,
    index?: number
  ) => void;
  isMobile?: boolean;
  togglePanel?: any;
  notifications?: INotification[];
  clearNotifications?: () => void;
}

export const GrecoPanel = (props: IProps) => {
  const isMobile = useIsMobile();
  const panelStyle = {
    // height: "calc(100vh - 50px)",
    // top: sizes.appHeader,
    width: isMobile ? "100%" : "400px",
    padding: 15,
  };

  const renderComponent = () => {
    if (props.panelType === GrecoPanelType.Notifications)
      return (
        <Notification
          strings={props.panelStrings as INotificationStrings}
          notifications={props.notifications}
          clearNotifications={props.clearNotifications}
        />
      );
    else if (props.panelType === GrecoPanelType.UserSettings)
      return (
        <SettingsPanel
          togglePanel={props.onDismiss}
          languageOptions={props.languageOptions || []}
          onSelect={props.onChangeLanguage}
          selectedLanguage={props.defaultSelectedLanguage || ""}
        />
      );
    else return <div></div>;
  };

  const restoreFocusTargetAttributes = useRestoreFocusTarget();
  const restoreFocusSourceAttributes = useRestoreFocusSource();

  return (
    <Container>
      <Drawer
        position="end"
        {...restoreFocusSourceAttributes}
        {...restoreFocusTargetAttributes}
        type={"overlay"}
        separator
        size="small"
        open={props.panelIsOpen}
        onOpenChange={() => props.onDismiss()}
        style={props.panelType !== GrecoPanelType.AppLauncher ? panelStyle : {}}
      >
        <DrawerHeader>
          <DrawerHeaderTitle
            action={
              <Button
                style={{
                  display: props.panelType === GrecoPanelType.AppLauncher ? "none" : "block",
                }}
                appearance="subtle"
                aria-label="Close"
                icon={<Dismiss24Regular />}
                onClick={() => props.onDismiss()}
              />
            }
          >
            {(props.panelStrings && props.panelStrings.panelTitle) || props.panelType}
          </DrawerHeaderTitle>
        </DrawerHeader>

        <DrawerBody
          style={{
            padding: 10,
          }}
        >
          {renderComponent()}
        </DrawerBody>
      </Drawer>
    </Container>
  );
};

const Container = styled.div``;
